import React from "react";

import "../style/MetalsTrading.css";

const MetalsTrading = () => {
  return (
    <div className="metals-container">
      <header className="metals-header">
        <h1>Metals Trading</h1>
        <p>Extrede   offers you exposure to the most popular precious metals<br/><br/> with consistently tight pricing.</p>
      </header>


      <h2 id="metals">Trade Metals CFDs with Extrede  </h2>
      <section className="metals-why-trade">
        
          <div className="text1">Extrede   allows trading the spot price for metals including Gold or Silver against the US Dollar or Australian Dollar as a currency pair on 500:1 leverage.
            <br/><br/>
            Open a trading account with Extrede  , and you will gain exposure to the available global market prices on trading gold CFDs and silver CFDs. Trading metal CFDs with Extrede  , a global regulated, multi-award-winning broker.
          </div>

          <div className="text2">
            <h3>What are the benefits of trading Metals ?</h3>
            <ul>
              <li><i class="fa-solid fa-check"></i>Trade in any direction you think the markets will go, short or long, maximising trading opportunities</li>
              <li><i class="fa-solid fa-check"></i>Powerful trading platforms MetaTrader 5 (MT5), with real-time gold and silver news and charts. Trade anytime, anywhere, across multiple devices</li>
              <li><i class="fa-solid fa-check"></i>Rich educational resources and Trading Tools to hone your Trading Strategies</li>
              <li><i class="fa-solid fa-check"></i>Hedge Risks – Hedge your investment risks with high value assets, like gold and silver</li>
              <li><i class="fa-solid fa-check"></i>Award-winning multilingual customer support</li>
              <li><i class="fa-solid fa-check"></i>No price manipulation, no requotes and no dealing desk</li>
              <li><i class="fa-solid fa-check"></i>Benefit from low margin, low-cost trading</li>
              <li><i class="fa-solid fa-check"></i>Benefit from low margin, low-cost trading, without compromising execution</li>
              
            </ul>
          </div>
      </section>


      
      <section className="metals-best-platform">
      <h2>What is the Best Platform to Trade Forex?</h2>
        <div className="content">
          <div className="text-content">
            
            <p>Discover the benefits of Forex trading on one of the most powerful trading platforms available, extrede 5 (extrede 5). Available across desktop and mobile platforms, the MetaTrader 5 platform is ready when you are.</p>
            <ul>
              <li>Spreads from 0.0 pips & leverage up to 500:1</li>
              <li>Customisable interface, including colours of technical indicators</li>
              <li>One-click trading</li>
              <li>MarketWatch</li>
              <li>Live price streaming on Live accounts and Demo accounts 128-bits encryption for secure trading</li>
              <li>Expert Advisors (EAs)</li>
              <li>Customisable alerts</li>
              <li>Compatible with iOS, Android, and Mac devices</li>
            </ul>
          </div>
          <div className="image-container">
            <img src="/images/foreex1.png" alt="Trading Platform" />
          </div>
        </div>
       </section>

      <br/><br/>

      
      <section className="comm-best-platform">
      <h2>What is Commodities Trading?</h2>
        <div className="content1">
            <div className="image-container">
                <img src="/images/comdity2.png" alt="Trading Platform" />
            </div>
          <div className="text-content1">
            
            <p>At Extrede  , we offer you exposure to the most popular precious metals that make up an important commodity asset class. Metals trading is closely linked to the outlook for the overall global markets and major currencies and metals are traded against major currencies in a similar way to other currency pairs on the platform.</p>
            <br/><br/>
            <p>Factors affecting precious metal prices include supply and demand, interest rates, economic uncertainty, industrial output and the strength of the dollar with precious metals like gold traditionally viewed as a safe haven in times of volatility. Traders can trade metals to express their outlook on certain industries or to hedge their trading portfolio.</p>
            <br/><br/>
            <p>Through careful analysis, CFD traders predict the potential direction of metals prices and attempt to capture gains based on price fluctuations in the short-term or long-term. The market is open 24 hours a day, 5 days a week.</p>
          </div>
          
        </div>
       </section>
       <br/><br/><br/>


       <section id="broker" className="comm-best-platform">
        <h2 id="trade">An Example of Leveraged CFD Trading</h2>
        <div className="content1">

          <div className="text-content1">
           
            <p>Suppose you want to trade CFDs, where the underlying asset is the XAUUSD a Metal, also known as Gold vs US Dollar. Let us suppose that the XAUUSD is trading at:</p>
          </div>

          <div className="image-container">
            <img src="/images/metals1.png" alt="Trading Platform" />
          </div> 
        </div>
      </section>

      <div className="profitloss">
          <div className="profit">
          <p>You decide to buy AUD 20,000 because you think that the AUD/USD price will rise in the future. Your margin rate is 5%. This means that you need to deposit 5% of the total position value into your margin account.</p><br/>
            <img src="/images/redmetals.png" alt="loss"/>
           
          </div>

          <div className="loss">
          <img src="/images/greenmetals.png" alt="profit"/><br/>
            <p>Now, in the next hour, if the price moves to 0.6880/0.6882, you have a winning trade. You could close your position by selling at the current price of AUD 0.6880.</p>
            
          </div>
         </div>




         <div className="metalcontent">

        <div className="metaltext">
        
        <p>In this case, the price of gold moved in your favor. But, had the price declined instead, moving against your prediction, you could have made a loss. This continuous evaluation of price movements and resultant profit/loss happens daily. Accordingly, it leads to a net return (positive/negative) on your initial margin. In the loss scenario where your free equity, (account balance+ Profit/Loss) falls below the margin requirements (358.4), the broker will issue a margin call. If you fail to deposit the money, and the market moves further against you, when your free equity reaches the 50% of your initial margin the contract will be closed at the current market price, known as “stop out.”</p>
        </div>

        <div className="metalimage">
        <img src="/images/metals2.png" alt="Trading Platform" />
        </div> 
        </div>

        <br/><br/><br/>
        <div className="image-container1">
            <img src="/images/metals3.png" alt="Trading Platform" />
        </div> 

        <br/><br/><br/>

        <h2 id="soft">Metal Spreads</h2>
        <div className="image-container1">
            <img src="/images/metals4.png" alt="Trading Platform" />
        </div> 

        <h1 id="metal">Why Trade Precious Metals with Extrede  ?</h1>
        <section className="TradeMetals">
            
            <div className="metaltext1">
                <p>Precious metals are among the Top Commodities To Trade Metals are classified as a hard commodity as they are mined from the earth or extracted from natural resources. Through Contracts For Difference (CFDs), you can gain exposure to metals markets in a unique way that provides a wide range of advantages.</p><br/>
                <p>  Margin Trading: As CFDs are a leveraged product, you can open large positions by depositing only the margin required. As metals such as gold have high levels of liquidity, commodities trading offers higher levels of leverage than many other tradable instruments.</p>
            </div>

            <div className="metaltext2">
                <p>  Go ‘Long’ or ‘Short’: One of the main attractions of CFDs is the ability to speculate in both rising and falling prices. The ability to open short positions and benefit from falling prices is a unique aspect of CFD trading and one that creates additional trading opportunities.</p><br/>
                <p>  Risk Management: Advanced trading platforms such MetaTrader 5 offer excellent risk management tools. Their features include a large range of charting tools but also a multitude of order types and alerts to ensure that you are made aware of any changes to market conditions.</p>
            </div>
        </section>

        <div className="factors">
            <h1>Factors Affecting Precious<br/>
            Metal Prices</h1>
            <p>1. Supply and Demand: Applicable across all products and services, the same also applies to precious metals. A shortage in metals or the increased demand for their use can affect prices. Let’s take industrial metals such as copper or aluminium. A technological advancement may create an alternative for their use and decrease their value.</p>
            <p>2. Macroeconomic Variables: Data relating to interest rates and GDP affect a significant amount of metals. One of the reasons is because metals are seen as a safe-haven, and an alternative investment to the cash rate provided by financial institutions.</p>
            <p>3. Market Conditions: Extrede   provides metals trading against many major currencies including the US dollar, similar to foreign exchange. Metals tend to be susceptible to the US dollar and have historically traded in the opposite direction to the greenback. This is why they are often used as part of a hedging strategy in times of economic uncertainty.</p>
            <p>4. Inflation: Anything that dilutes the value of a currency helps the performance of metals. Quantitative easing or the printing of additional money causes a rise in inflation with metal prices generally following suit.</p>
        </div>

        <div className="BenifitsMetals">
            <h1>Benefits of Trading Precious Metals</h1>
            <p><strong>Metals CFDs:</strong> As you do not have to not actually own the underlying asset when trading CFDs, there are fewer costs associated with investing in metals this way. There is no need to store the asset and traders can benefit in both rising and falling prices. The prices are comparable to those found on the London Metal Exchange (LME), the world’s largest market for ETFs on base metals and other metals.</p>
            <p><strong>Portfolio Diversification:</strong> With limited correlation to other financial instruments such as stocks and bonds, trading precious metals is a useful way to diversify your portfolio.</p>
            <p><strong>Hedging:</strong> Precious metals are often used as part of a risk management strategy. Investors often trade metals to hedge against inflation and currency.</p>
            <p><strong>Safe-Haven:</strong> During times of economic uncertainty, the value of precious metals tends to rise. This has historically been the case during economic slumps and key political events including major elections.</p>
        </div>

      
    </div>
  );
};

export default MetalsTrading;
